/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ naam: NonNullable<unknown> }} Planning_Rooster_Begin_VanInputs */

const nl_planning_rooster_begin_van = /** @type {(inputs: Planning_Rooster_Begin_VanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Begin van ${i?.naam}`)
};

/**

* @param {Planning_Rooster_Begin_VanInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_begin_van = /** @type {((inputs: Planning_Rooster_Begin_VanInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Begin_VanInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_begin_van(inputs)
});
export { planning_rooster_begin_van as "planning.rooster.begin_van" }